module.exports = "/_next/static/images/175077d5c5af21e228da63b0a480d7f3-digital-account-phone-main-screen@sm-2x.png.webp";